import { render, staticRenderFns } from "./USMultiselectInput.vue?vue&type=template&id=5f217c7c"
import script from "./USMultiselectInput.vue?vue&type=script&lang=js"
export * from "./USMultiselectInput.vue?vue&type=script&lang=js"
import style0 from "./USMultiselectInput.vue?vue&type=style&index=0&id=5f217c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports